import type {
  DocumentReviewQueueRow,
  DocumentReviewStep,
  ReviewRejectionReason,
} from 'src/interfaces/documentReview'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a selector
 * — every consuming `useSelector` would re-render on each dispatch. Filtering and sorting belong
 * in the component under `useMemo`.
 */
export const getDocumentReviewSteps = (state: State): DocumentReviewQueueRow[] => {
  return state.documentReview.steps
}

export const getDocumentReviewStepsLoading = (state: State): boolean => {
  return state.documentReview.stepsLoading
}

export const getDocumentReviewStepsError = (state: State): string | null => {
  return state.documentReview.stepsError
}

export const getDocumentReviewStep = (state: State): DocumentReviewStep | null => {
  return state.documentReview.step
}

export const getDocumentReviewStepLoading = (state: State): boolean => {
  return state.documentReview.stepLoading
}

export const getDocumentReviewStepError = (state: State): string | null => {
  return state.documentReview.stepError
}

export const getReviewRejectionReasons = (state: State): ReviewRejectionReason[] => {
  return state.documentReview.rejectionReasons
}

export const getDocumentReviewSubmitting = (state: State): boolean => {
  return state.documentReview.submitting
}
